import {
  LIST_PLANS_SUCCESS,
  LIST_PLANS_FAILED,
  CREATE_PLANS_SUCCESS,
  CREATE_PLANS_FAILED,
  CLEAR_PLANS_ERROR,
  SET_PLANS_ISOPEN,
  SET_PLAN_EDIT_DATA,
  SET_PLAN_DETAILS_LOADING,
  SET_ALERT_PLAN,
  CLEAR_EDIT_PLAN_DATA,
  LIST_PLAN_ASSETS_SUCCESS,
  LIST_PLAN_ASSETS_FAILED,
  SELECTED_PLAN_ID,
  TRIGGER_FILTER_DATA,
  AI_MODE_CONFIG,
  GENERATING_ML_DATA,
  GENERATING_ML_DATA_STATUS,
} from "../actions/types";
const initialState = {
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  data: [],
  isOpen: false,
  editData: {},
  planDetailsLoading: false,
  isAlert: false,
  alertType: null,
  alertMessage: null,
  editDataId: null,
  planAssets: [],
  planAssetsTotalCount: 0,
  planAssetsSites: [],
  planAssetsFilters: [],
  planAssetsFiltersStatus: "ready",
  selectedPlanId: null,
  triggerFilter: false,
  aiModeData: [],
  generatingLoading: false,
  mlgenerationMessage: false,
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case AI_MODE_CONFIG:
      return {
        ...state,
        aiModeData: payload,
      };
    case GENERATING_ML_DATA_STATUS:
      return {
        ...state,
        mlgenerationMessage: payload,
      };
    case GENERATING_ML_DATA:
      return {
        ...state,
        generatingLoading: payload,
      };
    case LIST_PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.data,
      };
    case LIST_PLANS_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        editDataId: null,
        editData: null,
      };
    case TRIGGER_FILTER_DATA:
      return {
        ...state,
        triggerFilter: payload,
      };
    case CREATE_PLANS_SUCCESS:
      return {
        ...state,
        isError: false,
        isErrorType: payload.type,
        errMessage: payload.message,
      };
    case CREATE_PLANS_FAILED:
      return {
        ...state,
        isError: true,
        isErrorType: payload.type,
        errMessage: payload.message,
      };
    case CLEAR_PLANS_ERROR:
      return {
        ...state,
        isError: false,
        isErrorType: null,
        errMessage: null,
        isOpen: false,
      };
    case SET_PLANS_ISOPEN:
      return {
        ...state,
        isOpen: payload,
      };
    case SELECTED_PLAN_ID:
      return {
        ...state,
        selectedPlanId: payload,
      };
    case SET_PLAN_EDIT_DATA:
      return {
        ...state,
        editData: payload.data,
        editDataId: payload.editDataId,
      };
    case SET_PLAN_DETAILS_LOADING:
      return {
        ...state,
        planDetailsLoading: payload,
      };
    case SET_ALERT_PLAN:
      return {
        ...state,
        isAlert: payload.status,
        alertMessage: payload.message,
        alertType: payload.type,
      };
    case CLEAR_EDIT_PLAN_DATA:
      return {
        ...state,
        editData: {},
        editDataId: null,
      };
    case LIST_PLAN_ASSETS_SUCCESS:
      return {
        ...state,
        planAssets: payload.data,
        planAssetsTotalCount: payload.total_count || 0,
        planAssetsSites: payload.sites || [],
        planAssetsFilters: payload.filters || [],
        planAssetsFiltersStatus: payload.filters_status || "ready",
      };
    case LIST_PLAN_ASSETS_FAILED:
      return {
        ...state,
        planAssets: [],
        planAssetsTotalCount: 0,
        planAssetsSites: [],
        planAssetsFilters: [],
        planAssetsFiltersStatus: "ready",
      };
    default:
      return state;
  }
}

export default companyReducer;
